export default __webpack_public_path__ + "static/O0284-e5b2bece9a3a6bb828d6c1c95fee38c8.png";